import {Component, OnInit} from '@angular/core';
import {AbstractQuoteComponent} from '../abstract-quote-component';
import {Person} from '../../../class/person';
import {Util} from '../../../util/util';
import {WelfareResultService} from '../../../service/welfare-result.service';
import {PersonKind} from '../../../class/person-kind.enum';

@Component({
  selector: 'app-rscquote',
  templateUrl: './rscquote.component.html',
  styleUrls: ['./rscquote.component.css']
})
export class RSCQuoteComponent extends AbstractQuoteComponent implements OnInit {

  husband: Person;
  wife: Person;

  constructor(private welfareResultService: WelfareResultService) {
    super();
  }

  ngOnInit() {
    this.husband = Util.getPersonByKind(this.welfareResultService.persons, PersonKind.HUSBAND);
    this.wife = Util.getPersonByKind(this.welfareResultService.persons, PersonKind.WIFE);
  }
}
